import { CartState } from './cart/cart.state';
import { ActionReducerMap } from '@ngrx/store';
import { cartReducer } from './cart/cart.reducer';
import { CartEffects } from './cart/cart.effects';
import { UserEffects } from './user/user.effects';
import { userReducer } from './user/user.reducer';
import { UserState } from './user/user.state';
import { AppStoreState } from './app-store/app-store.state';
import { AppStoreReducer } from './app-store/app-store.reducer';

export interface AppState {
  cart: CartState;
  user: UserState;
  appStore: AppStoreState;
}

export const reducers: ActionReducerMap<AppState> = {
  cart: cartReducer,
  user: userReducer,
  appStore: AppStoreReducer,
};

export const effects = [CartEffects, UserEffects];
